<p-dialog
  class="relative chat-history-drawer"
  header="Storico conversazione"
  [(visible)]="visible"
  (onHide)="close()"
  position="right"
  [draggable]="false"
  [modal]="true"
  [contentStyle]="{ overflow: 'hidden', position: 'relative' }"
>
  <!-- Loader -->
  <div *ngIf="loading" class="dialog-loader">
    <p-progressSpinner styleClass="full-spinner" strokeWidth="4"></p-progressSpinner>
  </div>

  <!-- Scroll container -->
  <div #scrollContainer class="chat-scroll" (scroll)="onScroll()">
    <app-message-bubble
      *ngFor="let msg of messages"
      [attr.data-message-id]="msg.id"
      [message]="msg"
      [disableActions]="true"
      [attr.data-anchor]="msg.id === anchorMessageId ? 'true' : null"
    ></app-message-bubble>
  </div>
</p-dialog>
